/* 130R: busca do tema (agente busca, 18/10/2026).
 * 1) Código sem hífen: "218102P000", "21810 2P000" e "546264d000" também acham "21810-2P000"/"54626-4D000".
 *    A busca do Shopify não entende OR; por isso o script consulta as formas do código (com hífen e sem)
 *    na busca instantânea e manda para a página de resultados a forma que acha mais peças.
 *    Texto ("coxim motor hb20") e código que já acha resultado seguem sem mudança.
 * 2) Sugestões enquanto digita (Predictive Search do Shopify, seção predictive-search.liquid), com
 *    combobox ARIA 1.2: setas, Enter, Esc, "Ver todos os resultados".
 * Vale para todo form[action=".../search"] da página (topo do computador, topo do celular, card da home e
 * qualquer outro), por delegação: não depende de onde o formulário está nem de quando ele aparece.
 * Liga/desliga as sugestões: Configurações do tema > "Disabled default Ajax Search suggestion" (disable_search_ajax).
 * Quantidade: Configurações do tema > Search > "Items to display" (search_limit, de 4 a 8 aqui). */
(function () {
  'use strict';
  if (window.R130Busca) return;
  if (/[?&]r130busca=0(&|$)/.test(location.search)) return; // comparação "antes": ?r130busca=0 desliga este script

  var tag = document.currentScript;
  var ds = (tag && tag.dataset) || {};
  var CFG = {
    suggest: ds.suggest || '/search/suggest',
    css: ds.css || '',
    sugestoes: ds.sugestoes !== '0',
    limite: Math.min(8, Math.max(4, parseInt(ds.limite, 10) || 6)),
    esgotados: ds.esgotados || 'last',
    minimo: 2,
    espera: 220,
    tempoEnvio: 1500
  };
  var celular = window.matchMedia ? window.matchMedia('(max-width: 991.98px)') : { matches: false };

  /* ---------------- 1. Código da peça ---------------- */
  var SEP = /[\s.\-_\/]+/g;
  var HK = /^(\d{5})([A-Z0-9]{5}[A-Z0-9]{0,3})$/; // Hyundai/Kia: 5 dígitos + 5 (sufixo opcional)

  function analisar(bruto) {
    var termo = String(bruto || '').trim().replace(/\s+/g, ' ');
    var up = termo.toUpperCase();
    var c = up.replace(SEP, '');
    var r = { termo: termo, compacto: c, codigo: false, variantes: [termo], padrao: termo };
    if (c.length < 6 || c.length > 16 || !/^[A-Z0-9]+$/.test(c)) return r;
    if ((c.match(/\d/g) || []).length < 4) return r;
    var hk = HK.exec(c);
    if (/\s/.test(up)) {
      // Com espaço, só vale como código no formato 21810 2P000 ou BBE 1045 (evita "hb20 2019").
      var partes = up.split(' ');
      var ok = (hk && partes.length === 2 && partes[0].replace(SEP, '').length === 5) || /^[A-Z]{2,4} \d{3,6}$/.test(up);
      if (!ok) return r;
    }
    var v = [];
    if (hk) v.push(hk[1] + '-' + hk[2]);
    var comHifen = up.replace(/\s+/g, '-');
    if (comHifen.indexOf('-') >= 0) v.push(comHifen);
    v.push(c);
    r.codigo = true;
    r.variantes = v.filter(function (x, i) { return v.indexOf(x) === i; });
    r.padrao = r.variantes[0];
    return r;
  }

  /* ---------------- 2. Consulta à busca instantânea (com cache) ---------------- */
  var cache = new Map();

  function urlSugestao(q, limite) {
    var p = new URLSearchParams();
    p.set('q', q);
    p.set('section_id', 'predictive-search');
    p.set('resources[type]', 'product,collection');
    p.set('resources[limit]', String(limite));
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', CFG.esgotados);
    return CFG.suggest + '?' + p.toString();
  }

  function pedir(q, limite) {
    var chave = q.toUpperCase() + '|' + limite;
    if (cache.has(chave)) return cache.get(chave);
    if (cache.size > 80) cache.clear();
    var pr = fetch(urlSugestao(q, limite), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cols = Array.prototype.slice.call(doc.querySelectorAll('[data-r130-sug-cols] > li'));
        var prods = Array.prototype.slice.call(doc.querySelectorAll('[data-r130-sug-prods] > li'));
        return { q: q, cols: cols, prods: prods, n: prods.length, limite: limite };
      })
      .catch(function (e) { cache.delete(chave); throw e; });
    cache.set(chave, pr);
    return pr;
  }

  function codigosDe(li) {
    return (li.getAttribute('data-codigos') || '').split(' ').filter(Boolean);
  }
  function bate(li, compacto, prefixo) {
    return codigosDe(li).some(function (c) {
      var k = c.toUpperCase().replace(SEP, '');
      return prefixo ? k.indexOf(compacto) === 0 : k === compacto;
    });
  }

  // Busca as formas do código, escolhe a principal e junta os produtos sem repetir.
  function sugestoes(an, limite) {
    if (!an.codigo) {
      return pedir(an.termo, limite).then(function (r) {
        return { termo: an.termo, cols: r.cols, prods: r.prods, mudou: false };
      });
    }
    return Promise.all(an.variantes.map(function (v) {
      return pedir(v, limite).catch(function () { return { q: v, cols: [], prods: [], n: -1 }; });
    })).then(function (rs) {
      var melhor = escolherEntre(an, rs);
      var ordem = rs.slice().sort(function (a, b) { return b.n - a.n; });
      var vistos = {}, prods = [];
      ordem.forEach(function (r) {
        r.prods.forEach(function (li) {
          var u = (li.getAttribute('data-url') || '').split('?')[0]; // o Shopify põe _psq=<termo> no link
          if (!vistos[u]) { vistos[u] = 1; prods.push(li); }
        });
      });
      var exatos = prods.filter(function (li) { return bate(li, an.compacto); });
      var resto = prods.filter(function (li) { return !bate(li, an.compacto); });
      prods = exatos.concat(resto);
      var cols = (ordem[0] && ordem[0].cols) || [];
      if (prods.length || !/^\d{5}/.test(an.compacto) || an.compacto.length >= 10) {
        return { termo: melhor, cols: cols, prods: prods.slice(0, limite), mudou: melhor !== an.termo };
      }
      // Código pela metade (ex.: "21810-2P"): o Shopify só acha o código inteiro; procura o grupo
      // de 5 dígitos e filtra pelos códigos que começam com o que foi digitado.
      return pedir(an.compacto.slice(0, 5), 10).then(function (r) {
        var p = r.prods.filter(function (li) { return bate(li, an.compacto, true); });
        return { termo: an.termo, cols: [], prods: p.slice(0, limite), mudou: false, parcial: true };
      }, function () { return { termo: an.termo, cols: [], prods: [], mudou: false }; });
    });
  }

  function escolherEntre(an, rs) {
    var max = -1, idx = 0;
    rs.forEach(function (r, i) { if (r.n > max) { max = r.n; idx = i; } });
    if (max < 0) return an.padrao; // sem resposta da rede: vai a forma padrão (com hífen, se for Hyundai/Kia)
    if (max === 0) return an.termo;
    var dig = an.termo.toUpperCase();
    for (var i = 0; i < rs.length; i++) {
      if (an.variantes[i] === dig && rs[i].n === max) return an.termo; // o que foi digitado já acha: não mexe
    }
    return an.variantes[idx];
  }

  // Termo final para a página de resultados.
  function termoFinal(an) {
    if (!an.codigo || an.variantes.length < 2) return Promise.resolve(an.termo);
    var lim = limiteAtual();
    return Promise.all(an.variantes.map(function (v) {
      return pedir(v, lim).catch(function () { return { n: -1 }; });
    })).then(function (rs) { return escolherEntre(an, rs); });
  }

  function comTempo(pr, ms, padrao) {
    return new Promise(function (ok) {
      var t = setTimeout(function () { ok(padrao); }, ms);
      pr.then(function (v) { clearTimeout(t); ok(v); }, function () { clearTimeout(t); ok(padrao); });
    });
  }

  /* ---------------- 3. Formulários de busca ---------------- */
  function ehFormBusca(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var a = f.getAttribute('action') || '';
    var cam;
    try { cam = new URL(a, location.href).pathname; } catch (e) { return false; }
    return /\/search\/?$/.test(cam) && !!f.querySelector('input[name="q"]');
  }
  function campoDe(el) {
    if (!el || el.tagName !== 'INPUT' || el.name !== 'q') return null;
    return ehFormBusca(el.form) ? el : null;
  }

  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!ehFormBusca(f)) return;
    if (f.getAttribute('data-r130-busca-ok') === '1') { f.removeAttribute('data-r130-busca-ok'); return; }
    var campo = f.querySelector('input[name="q"]');
    var an = analisar(campo.value);
    if (!an.codigo || an.variantes.length < 2) return;
    ev.preventDefault();
    f.setAttribute('aria-busy', 'true');
    comTempo(termoFinal(an), CFG.tempoEnvio, an.padrao).then(function (q) {
      campo.value = q;
      f.removeAttribute('aria-busy');
      if (f.requestSubmit) { f.setAttribute('data-r130-busca-ok', '1'); f.requestSubmit(); } else f.submit();
    });
  }, true);

  // Página de resultados aberta por link direto (Google, WhatsApp, favoritos) com o código sem hífen:
  // se a forma digitada não acha nada e outra forma acha, troca o endereço uma vez.
  (function () {
    if (!/\/search\/?$/.test(location.pathname)) return;
    var ps = new URLSearchParams(location.search);
    var q = ps.get('q');
    if (!q || ps.get('view')) return;
    var an = analisar(q);
    if (!an.codigo || an.variantes.length < 2) return;
    var marca = 'r130-busca-troca:' + q;
    try { if (sessionStorage.getItem(marca)) return; } catch (e) { /* segue */ }
    var lim = limiteAtual();
    Promise.all([pedir(an.termo, lim)].concat(an.variantes.map(function (v) { return pedir(v, lim); }))).then(function (rs) {
      var digitado = rs.shift();
      var novo = escolherEntre(an, rs);
      if (digitado.n !== 0 || !novo || novo === an.termo || !rs.some(function (r) { return r.n > 0; })) return;
      try { sessionStorage.setItem(marca, '1'); } catch (e) { /* segue */ }
      ps.set('q', novo);
      location.replace(location.pathname + '?' + ps.toString() + location.hash);
    }, function () {});
  })();

  /* ---------------- 4. Painel de sugestões (combobox) ---------------- */
  function limiteAtual() { return celular.matches ? Math.min(CFG.limite, 4) : CFG.limite; }

  var cssPronto = false;
  function carregarCss() {
    if (cssPronto || !CFG.css) return;
    cssPronto = true;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CFG.css;
    document.head.appendChild(l);
  }

  var painel, lista, aviso, nota, vazio, atual = null, ativo = -1, opcoes = [], seq = 0, timer = 0, ultimo = null, raf = 0;
  var SETA = '<svg class="r130-ico" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function criarPainel() {
    if (painel) return;
    carregarCss();
    painel = document.createElement('div');
    painel.className = 'r130-sug';
    painel.hidden = true;
    painel.innerHTML =
      '<p class="r130-sug__nota" hidden></p>' +
      '<p class="r130-sug__vazio" hidden></p>' +
      '<div class="r130-sug__lista" role="listbox" id="r130-sug-lista" aria-label="Sugestões de busca"></div>';
    nota = painel.querySelector('.r130-sug__nota');
    lista = painel.querySelector('[role="listbox"]');
    vazio = painel.querySelector('.r130-sug__vazio');
    aviso = document.createElement('div');
    aviso.className = 'r130-sug__sr';
    aviso.setAttribute('aria-live', 'polite');
    aviso.setAttribute('role', 'status');
    document.body.appendChild(painel);
    document.body.appendChild(aviso);
    // Clique no painel não tira o foco do campo (o link navega normalmente).
    painel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    painel.addEventListener('click', function (e) {
      var todos = e.target.closest('[data-r130-sug-todos]');
      if (todos && atual) { e.preventDefault(); enviar(atual); }
    });
  }

  function prepararCampo(campo) {
    criarPainel();
    if (campo.getAttribute('data-r130-busca') === '1') return;
    campo.setAttribute('data-r130-busca', '1');
    campo.setAttribute('role', 'combobox');
    campo.setAttribute('aria-autocomplete', 'list');
    campo.setAttribute('aria-expanded', 'false');
    campo.setAttribute('aria-controls', 'r130-sug-lista');
    campo.setAttribute('autocomplete', 'off');
    campo.setAttribute('autocapitalize', 'off');
    campo.setAttribute('spellcheck', 'false');
  }

  function enviar(campo) {
    fechar();
    var f = campo.form;
    if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })) && f.submit();
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function marcarCodigo(li, an) {
    if (!an.codigo) return;
    var alvo = li.querySelector('[data-r130-sug-cod] b');
    if (!alvo) return;
    var cods = codigosDe(li), achado = null;
    for (var i = 0; i < cods.length && !achado; i++) if (cods[i].toUpperCase().replace(SEP, '') === an.compacto) achado = cods[i];
    for (var j = 0; j < cods.length && !achado; j++) if (cods[j].toUpperCase().replace(SEP, '').indexOf(an.compacto) === 0) achado = cods[j];
    if (achado) { alvo.textContent = achado; li.querySelector('[data-r130-sug-cod]').classList.add('r130-sug__cod--bate'); }
  }

  function grupo(id, titulo, itens) {
    var ul = document.createElement('ul');
    ul.className = 'r130-sug__grupo';
    ul.setAttribute('role', 'group');
    ul.setAttribute('aria-labelledby', id);
    var h = document.createElement('li');
    h.id = id; h.className = 'r130-sug__titulo'; h.setAttribute('role', 'presentation');
    h.textContent = titulo;
    ul.appendChild(h);
    itens.forEach(function (li) { ul.appendChild(document.importNode(li, true)); });
    return ul;
  }

  function mostrar(campo, an, r) {
    criarPainel();
    var limCols = celular.matches ? 1 : 2;
    var cols = r.cols.slice(0, limCols);
    lista.innerHTML = '';
    if (cols.length) lista.appendChild(grupo('r130-sug-g-cat', 'Categorias', cols));
    if (r.prods.length) {
      var g = grupo('r130-sug-g-pec', r.parcial ? 'Peças com código começando por ' + an.termo.toUpperCase() : 'Peças', r.prods);
      Array.prototype.forEach.call(g.querySelectorAll('[role="option"]'), function (li) { marcarCodigo(li, an); });
      lista.appendChild(g);
    }
    var todos = document.createElement('div');
    todos.className = 'r130-sug__opt r130-sug__opt--todos';
    todos.setAttribute('role', 'option');
    todos.setAttribute('aria-selected', 'false');
    todos.setAttribute('data-r130-sug-todos', '');
    todos.innerHTML = '<a class="r130-sug__link" href="' + esc(urlBusca(campo.form, r.termo)) + '" tabindex="-1"><span>Ver todos os resultados para <b>' + esc(r.termo) + '</b></span>' + SETA + '</a>';
    lista.appendChild(todos);

    opcoes = Array.prototype.slice.call(lista.querySelectorAll('[role="option"]'));
    opcoes.forEach(function (o, i) { o.id = 'r130-sug-op-' + i; });
    ativo = -1;
    painel.scrollTop = 0;
    campo.removeAttribute('aria-activedescendant');

    if (r.mudou) { nota.hidden = false; nota.innerHTML = 'Mostrando resultados para <b>' + esc(r.termo) + '</b>'; }
    else nota.hidden = true;
    var nada = !cols.length && !r.prods.length;
    vazio.hidden = !nada;
    if (nada) {
      var msg = 'Olá! Estou no site da 130R Parts e procuro a peça ' + an.termo + '. Modelo, ano e chassi:';
      vazio.innerHTML = 'Nenhuma sugestão rápida para <b>' + esc(an.termo) + '</b>. Confira o código ou ' +
        '<a href="https://wa.me/5511910801297?text=' + encodeURIComponent(msg) + '" target="_blank" rel="noopener">consulte no WhatsApp</a>.';
    }
    abrir(campo);
    var n = opcoes.length - 1;
    aviso.textContent = nada ? 'Nenhuma sugestão.' : (n + (n === 1 ? ' sugestão' : ' sugestões') + '. Use as setas para escolher.');
  }

  function urlBusca(f, termo) {
    var ps = new URLSearchParams(new FormData(f));
    ps.set('q', termo);
    var a = f.getAttribute('action') || '/search';
    return a.split('?')[0] + '?' + ps.toString();
  }

  function abrir(campo) {
    atual = campo;
    painel.hidden = false;
    campo.setAttribute('aria-expanded', 'true');
    posicionar();
    window.addEventListener('scroll', aoMover, true);
    window.addEventListener('resize', aoMover);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', aoMover);
  }

  function fechar() {
    if (!painel || painel.hidden) return;
    painel.hidden = true;
    if (atual) { atual.setAttribute('aria-expanded', 'false'); atual.removeAttribute('aria-activedescendant'); }
    ativo = -1;
    window.removeEventListener('scroll', aoMover, true);
    window.removeEventListener('resize', aoMover);
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', aoMover);
  }

  function aoMover(e) {
    if (e && e.type === 'scroll' && painel && e.target && painel.contains(e.target)) return;
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; posicionar(); });
  }

  function posicionar() {
    if (!atual || painel.hidden) return;
    var ancora = atual.parentElement || atual;
    var r = ancora.getBoundingClientRect();
    var vv = window.visualViewport;
    var altura = vv ? vv.height + vv.offsetTop : window.innerHeight;
    if (r.bottom < 0 || r.top > altura) { fechar(); return; }
    var largura = document.documentElement.clientWidth;
    if (largura < 768) {
      painel.style.left = '8px';
      painel.style.width = (largura - 16) + 'px';
    } else {
      var w = Math.min(Math.max(r.width, 420), 640, largura - 16);
      var left = Math.min(Math.max(8, r.left), largura - w - 8);
      painel.style.left = Math.round(left) + 'px';
      painel.style.width = Math.round(w) + 'px';
    }
    var barra = 0;
    if (largura < 992) {
      var mb = document.getElementById('mobile-bar');
      if (mb && mb.offsetHeight && (!vv || vv.height > window.innerHeight * 0.8)) barra = mb.offsetHeight; // teclado fechado: desconta a barra de baixo
    }
    var top = Math.round(r.bottom + 6);
    painel.style.top = top + 'px';
    painel.style.maxHeight = Math.max(160, Math.floor(altura - top - 8 - barra)) + 'px';
    caber();
  }

  // Sem barra de rolagem dentro da lista (Baymard): se não cabe na tela (teclado do celular aberto,
  // campo no meio da página), esconde as últimas peças; "Ver todos os resultados" fica sempre visível.
  function caber() {
    var itens = Array.prototype.slice.call(lista.querySelectorAll('.r130-sug__opt--prod, .r130-sug__opt--col'));
    itens.forEach(function (li) { li.hidden = false; });
    var max = parseFloat(painel.style.maxHeight) || Infinity;
    var prods = itens.filter(function (li) { return li.classList.contains('r130-sug__opt--prod'); });
    var cols = itens.filter(function (li) { return li.classList.contains('r130-sug__opt--col'); });
    for (var i = prods.length - 1; i >= 2 && painel.scrollHeight > max + 1; i--) prods[i].hidden = true;
    for (var k = cols.length - 1; k >= 1 && painel.scrollHeight > max + 1; k--) cols[k].hidden = true;
    var antes = ativo >= 0 ? opcoes[ativo] : null;
    opcoes = Array.prototype.slice.call(lista.querySelectorAll('[role="option"]')).filter(function (o) { return !o.hidden; });
    ativo = antes ? opcoes.indexOf(antes) : -1;
    if (antes && ativo < 0) { antes.setAttribute('aria-selected', 'false'); if (atual) atual.removeAttribute('aria-activedescendant'); }
  }

  function mover(campo, passo) {
    if (!opcoes.length) return;
    if (ativo >= 0 && opcoes[ativo]) opcoes[ativo].setAttribute('aria-selected', 'false');
    ativo = ativo + passo;
    if (ativo >= opcoes.length) ativo = 0;
    if (ativo < 0) ativo = opcoes.length - 1;
    var o = opcoes[ativo];
    o.setAttribute('aria-selected', 'true');
    campo.setAttribute('aria-activedescendant', o.id);
    o.scrollIntoView({ block: 'nearest' });
  }

  function atualizar(campo) {
    clearTimeout(timer);
    var an = analisar(campo.value);
    var chave = an.termo.toUpperCase();
    if (an.compacto.length < CFG.minimo && an.termo.length < CFG.minimo) { ultimo = null; fechar(); return; }
    timer = setTimeout(function () {
      var meu = ++seq;
      var lim = limiteAtual();
      sugestoes(an, lim).then(function (r) {
        if (meu !== seq || document.activeElement !== campo) return;
        ultimo = { chave: chave, an: an, r: r };
        mostrar(campo, an, r);
      }, function () { /* sem rede: fica sem sugestões, a busca normal continua */ });
    }, CFG.espera);
  }

  if (CFG.sugestoes) {
    document.addEventListener('focusin', function (e) {
      var campo = campoDe(e.target);
      if (!campo) return;
      prepararCampo(campo);
      carregarCss();
      if (atual && atual !== campo) fechar();
      atual = campo;
      if (ultimo && campo.value.trim() && ultimo.chave === analisar(campo.value).termo.toUpperCase()) mostrar(campo, ultimo.an, ultimo.r);
    });
    document.addEventListener('input', function (e) {
      var campo = campoDe(e.target);
      if (!campo) return;
      prepararCampo(campo);
      atual = campo;
      atualizar(campo);
    });
    document.addEventListener('focusout', function (e) {
      if (!campoDe(e.target)) return;
      setTimeout(function () {
        if (document.activeElement !== atual) fechar();
      }, 120);
    });
    document.addEventListener('keydown', function (e) {
      var campo = campoDe(e.target);
      if (!campo || e.isComposing) return;
      var aberto = painel && !painel.hidden && atual === campo;
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          if (!aberto) { if (ultimo) mostrar(campo, ultimo.an, ultimo.r); else atualizar(campo); return; }
          mover(campo, 1); break;
        case 'ArrowUp':
          if (!aberto) return;
          e.preventDefault(); mover(campo, -1); break;
        case 'Enter':
          if (!aberto || ativo < 0 || !opcoes[ativo]) return; // envia o formulário normalmente
          e.preventDefault();
          if (opcoes[ativo].hasAttribute('data-r130-sug-todos')) { enviar(campo); return; }
          var a = opcoes[ativo].querySelector('a');
          fechar();
          if (a) window.location.href = a.href;
          break;
        case 'Escape':
          if (aberto) { e.preventDefault(); fechar(); }
          else if (campo.value) { e.preventDefault(); campo.value = ''; ultimo = null; }
          break;
        case 'Tab':
          fechar(); break;
      }
    });
    document.addEventListener('pointerdown', function (e) {
      if (!painel || painel.hidden) return;
      if (painel.contains(e.target) || (atual && atual.contains(e.target))) return;
      fechar();
    });
    // Folha de estilo sem atrasar a primeira pintura.
    if (document.readyState === 'complete') setTimeout(carregarCss, 1500);
    else window.addEventListener('load', function () { setTimeout(carregarCss, 1500); });
  }

  window.R130Busca = { analisar: analisar, sugestoes: sugestoes, termoFinal: termoFinal, config: CFG };
})();
